import { Breadcrumbs, Theme, Typography, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import KenColors from '../../Helpers/Themes/kenColors';

const useStyles = makeStyles((theme: Theme) => ({
  mainText: {
    // fontSize: '20px !important',
    fontWeight: '600 !important',
    textDecoration: 'none',
    textTransform: 'capitalize',
    margin: '0px !important',
    padding: '0px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '13px !important',
    },
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      fontSize: '20px !important',
    },
    '@media ()': {
      marginBottom: '10px !important',
    },
  },
  listText: {
    textDecoration: 'none',
    textTransform: 'capitalize',
    margin: '0px !important',
    padding: '0px !important',
  },
}));

const AppBreadCrumbs: React.FunctionComponent = () => {
  const { pathname, state } = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width:1025px)'); // Matches screens <= 'md'
  const classes = useStyles();
  const [albumTitle, setAlbumTitle] = useState<string>('');

  const navigateHistory: Array<string> = decodeURIComponent(pathname)
    .split('/')
    .filter((items) => {
      return items && items !== '';
    });
  const navigateState: null | string = state?.breadCrumbs;
  let customPath: string = '';

  useEffect(() => {
    if (navigateHistory[0] === 'album' && navigateHistory[1]) {
      const albumsData = localStorage.getItem('albumsData');
      if (albumsData) {
        try {
          const albums = JSON.parse(albumsData);
          const currentAlbum = albums.find((album: any) => album.Id === navigateHistory[1]);
          if (currentAlbum) {
            setAlbumTitle(currentAlbum.Name);
          }
        } catch (error) {
          console.error('Error parsing albums data:', error);
        }
      }
    }
  }, [navigateHistory]);

  const getDisplayName = (routeName: string, index: number) => {
    let displayName = routeName
      .replace(/([a-z])([A-Z])/g, '$1 $2') // add space between lowercase and uppercase
      .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2') // handle multiple uppercase correctly
      .replace(/-/g, ' ') // in case kebab-case is also used
      .trim();

    if (routeName === 'PhotoAlbumUpload') {
      return 'Photo Upload';
    }

    if (routeName === 'album' && index === 0) {
      return 'Album';
    }

    if (index === 1 && navigateHistory[0] === 'album' && albumTitle) {
      return albumTitle;
    }

    return displayName;
  };

  const getNavigationPath = (index: number, item: string): string => {
    if (index === 0 && item === 'album') {
      return '/photos';
    }

    let path = '';
    for (let i = 0; i <= index; i++) {
      path += `/${navigateHistory[i]}`;
    }
    return path;
  };

  const getBreadcrumbItems = () => {
    if (navigateHistory.length > 0 && navigateHistory[0] === 'businessdirectory' && state?.businessName) {
      return [
        { path: '/businessdirectory', name: 'Business Directory' },
        { path: '/businessdirectory', name: state.businessName, isLast: true },
      ];
    }

    if (navigateHistory.length === 1 && navigateHistory[0] === 'PhotoAlbumUpload') {
      return [
        { path: '/photos', name: 'Photos' },
        { path: '/PhotoAlbumUpload', name: 'Photo Upload', isLast: true },
      ];
    }

    return navigateHistory.map((item, index) => {
      const isLastIndex = index === navigateHistory.length - 1;
      const path = getNavigationPath(index, item);
      return {
        path,
        name: getDisplayName(item, index),
        isLast: isLastIndex,
      };
    });
  };

  return (
    <>
      <Typography className={classes.mainText} color={KenColors.ClientBlack2} fontSize={'0.9375rem'}>
        {getDisplayName(navigateHistory[0], 0)}
      </Typography>
      {isMobile ? null : (
        <>
          {(navigateHistory.length > 1 || navigateHistory[0] === 'PhotoAlbumUpload') && (
            <Grid>
              <Breadcrumbs separator={<Typography sx={{ fontSize: '0.75rem', fontWeight: '500' }}>&gt;</Typography>} style={{ color: '#3061FF' }}>
                {getBreadcrumbItems().map((item, index) => {
                  return item.isLast && navigateState ? (
                    <Typography key={index} className={classes.listText} color={'#193389'} fontSize={'0.75rem'}>
                      {navigateState}
                    </Typography>
                  ) : (
                    <Link key={index} className={classes.listText} to={item.path}>
                      <Typography sx={{ color: item.isLast ? KenColors.ClientBlack2 : '#3061FF', fontWeight: item.isLast ? '400' : '600', fontSize: '0.75rem' }}>{item.name}</Typography>
                    </Link>
                  );
                })}
              </Breadcrumbs>
            </Grid>
          )}
        </>
      )}
    </>
  );
};

export default AppBreadCrumbs;
